// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__Lobb3","videoOverlay":"styles_videoOverlay__6jAol","playButton":"styles_playButton__gvsWz"};